/**
 * @Author:      jiang.weiwei
 * @DateTime:    2017-12-06 20:13:08
 * @Description: 后台-pgc-标签管理-一级标签
 */
'use strict';
angular.module("userManagementForRoleModule",[
"addUsersForRoleServiceModule",
]).
controller('userManagementForRoleCtrl', ['$scope','$state','$stateParams','httpService','modalDialog','addUsersForRoleService',function($scope,$state,$stateParams,httpService,modalDialog,addUsersForRoleService){
    initStatus();
    initData();
    /**
     * [initStatus description] 初始化参数
     */
    function initStatus(){
        $scope.status = {
            inputData:''
        }
        $scope.page = {
            "CURRPAGE": 1,
            "PAGESIZE": 20,
            "ITEMCOUNT": 2000
        };
        $scope.data = {
            roleId: $stateParams.roleId,
            roleName:$stateParams.roleName,
            selectedArray:[]//选中的数据
        }
    };

    function initData(){
		requestData();
		
    };
    /**
     * [requestData description] 初始数据
     * @return {[type]} [description]
     */
    $scope.requestData = function(){
    	requestData();
    }
    /**
     * [selectDoc description] 单选
     * @param  {[type]} item [description] 当前数据
     * @return {[type]}      [description]
     */
    $scope.selectTag = function(item) {
        var index = $scope.data.selectedArray.indexOf(item);
        index > -1 ? $scope.data.selectedArray.splice(index, 1) : $scope.data.selectedArray.push(item);
    };
    /**
     * [selectPanel description] 全选当前面板的稿件
     * @param  {[type]} items [description] 当前面板
     * @return {[type]}       [description]
     */
    $scope.selectPanel = function(items) {
        if ($scope.data.listData.length > 0 && $scope.data.selectedArray.length == $scope.data.listData.length) {
            $scope.data.selectedArray = [];
        } else {
            $scope.data.selectedArray = [].concat($scope.data.listData);
        }
    };
    function requestData(){
        var params = {
      	  	roleId:$scope.data.roleId, 
      		currPage:$scope.page.CURRPAGE,
      		pageSize:$scope.page.PAGESIZE
        }
		$scope.loadingPromise = httpService.http("/mcnadmin/admin/role/listUserByRole.do", params, "post").then(function(data) {
            $scope.data.listData = data.data.ldata;
            $scope.page = {
                CURRPAGE: data.data.startPage,
                PAGESIZE: data.data.pageSize,
                ITEMCOUNT: data.data.totalResults,
                PAGECOUNT: data.data.totalPages
            };
        })
    }
    /**
     * [addUsersByRoleId description] 为角色添加用户
     * @return {[type]} [description]
     */
    $scope.addUsersByRoleId = function(){
    	addUsersForRoleService.addUsersForRole($scope.data.roleId).then(function() {
	    		requestData();
        });
    }
    
    /**
     * [deleteUsersByRoleId description] 为角色删除用户
     * @return {[type]} [description]
     */
    $scope.deleteUsersByRoleId = function(){
    	var params = {
    		roleId:$scope.data.roleId,
    		userIds:angular.packageIds($scope.data.selectedArray,",","id")
    	};
    	modalDialog.backConfirmModal("删除", "确认删除已选的用户？", function() {
	            httpService.http("/mcnadmin/admin/role/delRoleUsers.do", params, "post").then(function(data) {
	            	modalDialog.alertType('','删除用户成功','success');
	                requestData();
	            });
	        });
    }
}]);